import { PageError } from '@/components/PageError'
import { Block } from '@/components/Block'
import { crtVersionDraftsAtom } from '@/stores/crt'
import { useAtomValue } from 'jotai'
import { useMe } from '@/hooks/queries/useMe'
import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth')({
  component: RouteComponent,
})

function RouteComponent() {
  const { data: me, error } = useMe()
  const navigate = useNavigate()
  // Unsaved CRT configure edits are kept in memory: they follow the user across the app's pages, but leaving
  // the site would lose them. Guarded here, so it holds after leaving the CRT module with edits pending.
  const hasCrtDrafts = Object.keys(useAtomValue(crtVersionDraftsAtom)).length > 0

  if (!me) return null
  if (me.permissions && me.permissions.length === 0) navigate({ to: '/unverified' })
  if (error) return <PageError message={error.message} global />

  return (
    <>
      <Outlet />
      <Block shouldBlock={hasCrtDrafts} isInAppNavigationBlocked={false} />
    </>
  )
}
